import { ROUTES } from 'configs/routes/constants';

import { TRANSLATE_LABELS_DICTIONARY } from './constants';

import MembershipStore from '../membership/MembershipStore';

const ONLINE_EVENT_REMOVED_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.REPORTS,
  ROUTES.CONTENT.NEW_QUIZ,
  ROUTES.CONTENT.EDIT_QUIZ
];

export const filterOnlineEventRoutes = (routes) => {
  return routes.filter(
    (route) =>
      !ONLINE_EVENT_REMOVED_ROUTES.some((removedRoute) =>
        route.path.startsWith(removedRoute)
      )
  );
};

export const onlineEventLabelHandler = (label) => {
  if (MembershipStore.forceOnlineCourseLabels || !MembershipStore.onlineEvent) {
    return label;
  }

  const resultLabel = TRANSLATE_LABELS_DICTIONARY[label];

  if (!resultLabel) {
    return label;
  }

  return resultLabel;
};
